import type { IItem } from '@/types';
import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IItemInfoBatchInfoProps extends Omit<IItem, 'category' | 'fragility'> {}

export const ItemInfo: React.FC<IItemInfoBatchInfoProps> = ({
  height,
  length,
  name,
  weight,
  width,
}): JSX.Element => {
  const { t } = useTranslation();

  const isPriceVisible = height && length && weight && width;

  return (
    <Box>
      <Text textTransform="uppercase">{t('QUOTE_DETAILS.ITEM_INFO')}</Text>
      <Text fontSize="h4" fontWeight="bold" textTransform="capitalize">
        {name}
      </Text>
      {isPriceVisible && (
        <Text>
          {width} x {height} x {length} cm <br /> {weight} kg
        </Text>
      )}
    </Box>
  );
};
